module.exports = __webpack_public_path__ + "static/img/rank_212.964894a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_212.png
// module id = nxta
// module chunks = 0